module.exports = __webpack_public_path__ + "img/calendar.ea22ad48.svg";